import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes';

import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate'
import vueMoment from 'vue-moment';
import './ml';
import store from './store';

import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

import * as firebase from "firebase/app";
import "firebase/analytics";
import {VueReCaptcha} from 'vue-recaptcha-v3'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'

const firebaseConfig = {
    apiKey: "AIzaSyBRbSm7ZE5ofSJxHan56oyF9tr9SxXcHw4",
    authDomain: "quickrate-252306.firebaseapp.com",
    databaseURL: "https://quickrate-252306.firebaseio.com",
    projectId: "quickrate-252306",
    storageBucket: "quickrate-252306.appspot.com",
    messagingSenderId: "476870467397",
    appId: "1:476870467397:web:564d3e2084a0777a57e82c",
    measurementId: "G-8EH15K363E"
};

firebase.initializeApp(firebaseConfig);

Vue.component('GmapCluster', GmapCluster)
Vue.component('google-maps-circle', VueGoogleMaps.Circle)

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBxHgF7k7yUZ-meW9KbqCPP0oPL5WHSnwo",
        libraries: "places", // necessary for places input,
    }
});

Vue.use(VueReCaptcha, {
    siteKey: '6Lf1F7wZAAAAAHcJTpfFv5HPFIPkLT-kK6USTOmU',
    loaderOptions: {
        autoHideBadge: true
    }
})

Vue.use(VueMaterial)

Vue.use(Vuelidate)
Vue.use(vueMoment);
Vue.use(VueRouter);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;


const router = new VueRouter({mode: 'history', routes});

router.beforeEach((to, from, next) => {
    store.commit('setRoute___', to);
    if (to.matched.some((record) => record.meta.checkIfVoted)) {
        if (!router.app.$store.state.voted) {
            next()
        } else {
            router.push(from.path);
        }
    } else {
        next()
    }
})

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
